var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCircleError = function SvgIconCircleError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.118 11.404a1 1 0 0 1 1.764 0l8.334 15.625a1 1 0 0 1-.883 1.471H11.667a1 1 0 0 1-.883-1.47l8.334-15.626Zm-.055 5.846a.937.937 0 1 1 1.875 0v3.125a.937.937 0 1 1-1.875 0V17.25Zm2.187 7.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "IconCircleError_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.118 11.404a1 1 0 0 1 1.764 0l8.334 15.625a1 1 0 0 1-.883 1.471H11.667a1 1 0 0 1-.883-1.47l8.334-15.626Zm-.055 5.846a.937.937 0 1 1 1.875 0v3.125a.937.937 0 1 1-1.875 0V17.25Zm2.187 7.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
    fill: "#fff"
  }))));
};
export default SvgIconCircleError;